import { type Component } from "vue";
import { type RouteRecordRaw } from "vue-router";

export function architectKeyRoutes(MainLayout: Component): RouteRecordRaw {
  return {
    path: "/architect-keys",
    component: MainLayout,
    children: [
      {
        path: "",
        component: () =>
          import("core-fe-lib/components-shadcn/layouts/PassthroughLayout.vue"),
        children: [
          {
            path: "",
            name: "architectkey-list",
            component: () =>
              import("@/modules/architectkey/pages/ArchitectKeysPage.vue"),
            meta: { requiresAuth: true },
          },
        ],
      },
    ],
  };
}
